export const DataSourceDetailUserContextParam = {
    schemaFilter: { paramType: 'string' },
};

//# sourceMappingURL=DataSourceDetailUserContextParams.js.map
